import "./styles.css";
import React, { useEffect, useState } from "react";
import { SteamAppList } from "./SteamAppList";

interface AppCardProps {
  name: string;
  description: string;
  imageUrl: string;
}

interface SteamAppData {
  name: string;
  steam_appid: number;
  header_image: string;
  short_description: string;
  // Add other fields you need
}

interface SteamAPIResponse {
  [appId: string]: {
    success: boolean;
    data: SteamAppData;
  };
}

async function fetchAppInfo(appId: number): Promise<SteamAppData> {
  const url =
    "https://steamapp-resolver.wglnd.workers.dev/?appid=" + appId;

  const resp = await fetch(url);
  console.log(resp);
  if (!resp.ok) {
    throw new Error(`HTTP error ${resp.status}`);
  }
  const data: SteamAPIResponse = await resp.json();
  return data[appId].data;
}

const AppCard: React.FC<AppCardProps> = (props) => {
  return (
    <div className="card">
      <img src={props.imageUrl} alt="Game image" className="cardImage" />
      <div className="cardContent">
        <div>
          <strong>{props.name}</strong>
        </div>
        <div>{props.description}</div>
      </div>
    </div>
  );
};

function proxyImage(url: string) {
  return `https://images.weserv.nl/?url=${encodeURIComponent(url)}`;
}

export default function App() {
  const [search, setSearch] = useState<string>("");
  const [hoveredId, setHoveredId] = useState<number | null>(null);
  const [appCardData, setAppCardData] = useState<SteamAppData | null>(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e: React.MouseEvent) => {
    setPosition({ x: e.clientX + 10, y: e.clientY + 10 }); // offset to not overlap cursor
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    hoveredId && fetchAppInfo(hoveredId).then(setAppCardData);
  }, [hoveredId]);

  return (
    <div className="App" onMouseMove={handleMouseMove}>
      <div>
        Search for games:
        <input
          type="text"
          value={search}
          onChange={handleChange}
          placeholder=""
        ></input>
      </div>

      <SteamAppList searchPhrase={search} onHover={setHoveredId} />
      {appCardData && (
        <div
          style={{
            top: `${position.y}px`,
            left: `${position.x}px`,
            position: "fixed",
          }}
        >
          <AppCard
            name={appCardData.name}
            description={appCardData.short_description}
            imageUrl={proxyImage(appCardData.header_image)}
          />
        </div>
      )}
    </div>
  );
}
